module.exports = __webpack_public_path__ + "img/lr_13.b60d7108.png";